import React from 'react';
import {
  Button,
  Text,
  Spinner,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  Box,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const IsDeactivateModal = ({
  isOpen,
  onClose,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  isLoading = false,
  confirmColorScheme = 'blue',
  isActivating = false,
}) => {
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent
          maxWidth="400px"
          borderRadius="lg"
          boxShadow="lg"
          p={4}
        >
          <AlertDialogBody
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={6}
          >
            <Box
              as={isActivating ? FaTimesCircle : FaCheckCircle}
              size={60}
              color={isActivating ? 'red.500' : 'green.500'}
              mb={4}
            />
            <Text fontSize="18px" fontWeight="medium" textAlign="center" mt={5}>
              {description}
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter justifyContent="center">
            <Button
              variant="outline"
              onClick={onClose}
              padding="10px 20px"
              mr={4}
            >
              {cancelText}
            </Button>
            <Button
              colorScheme={confirmColorScheme}
              onClick={() => onConfirm()}
              padding="10px 20px"
              isDisabled={isLoading}
            >
              {isLoading ? <Spinner size="md" color="white" /> : confirmText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

IsDeactivateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  description: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  confirmColorScheme: PropTypes.string,
  isActivating: PropTypes.bool,
};

export default IsDeactivateModal;
